import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`

export const Button = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  margin: 4px 0px -1px;
  padding: 0px;
  border: 0px;
  gap: 7px;
`

export const Image = styled.img`
  width: 22px;
  height: 22px;
`

export const ButtonText = styled.p`
  color: #35A7FF;
  font-size: 14px;
  text-align: center;
  margin: 0px;
`
